import React, { FunctionComponent } from "react";

import { IField } from "@/types/hubspot";

type Props = {
  field: IField;
  error?: string;
};
const FormFieldError: FunctionComponent<Props> = ({ field, error }) => {
  if (!error) return <></>;

  return (
    <div id={`error-${field.name}`} className="mt-2 flex items-center gap-2">
      <span className="flex h-4 w-4 items-center justify-center rounded-full border-2 border-red-600 text-xs text-red-600">
        !
      </span>
      <span className="text-sm text-red-600">{error}</span>
    </div>
  );
};

export default FormFieldError;
